<script setup lang="ts">
const props = withDefaults(defineProps<{
  title?: string
  button: StoryBlokButton[]
  secondaryButton?: StoryBlokButton[]
  countryCode: string
  checkbox?: FieldContent[]
}>(), {
  checkbox: () => [] as FieldContent[],
})

const emit = defineEmits(['click'])
const form = ref<any>({})

const sb = useStoryblokApiV2()
const fields = (await sb.getForm(`/${props.countryCode}/spz-calculator`) as StoryBlokForm).fields

function onSubmit(formValues: any) {
  const value = formValues?.type != 'none' ? formValues?.inputValueSpz || formValues?.inputValueVin || '' : 'nospz'
  emit('click', value, formValues?.type)
}
</script>

<template>
  <FormSimple
    ref="form"
    class="bg-white flex flex-col gap-2.5 p-5 rounded-xl border-1 border-gray-light"
    :fields="[...fields, ...checkbox]"
    @submit="onSubmit"
  >
    <h3 v-html="title" />
    <FormFieldRadioButtons name="type" />
    <FormFieldText
      v-if="form.values?.type === 'spz'"
      name="inputValueSpz"
      :mask="{ mask: /^[a-zA-Z0-9]{0,7}$/, prepare: (val: string) => val.toUpperCase() }"
    >
      <template #start>
        <div class="bg-[#003399] flex items-center justify-center p-2.2 rounded-l-9px">
          <div class="flex-col items-center">
            <nuxt-icon name="core/euStars" filled class="text-xs" />
            <div class="text-white text-[12px] pt-0.5">
              {{ props.countryCode }}
            </div>
          </div>
        </div>
      </template>
    </FormFieldText>
    <FormFieldText
      v-else-if="form.values?.type === 'vin'"
      name="inputValueVin"
      :mask="{ mask: /^[a-zA-Z0-9]{0,17}$/, prepare: (val: string) => val.toUpperCase() }"
    >
      <template #start>
        <div class="bg-black text-white text-[12px] px-1.3 pt-6.1 pb-2 rounded-l-[9px]">
          VIN
        </div>
      </template>
    </FormFieldText>
    <!-- <FormFieldCheckbox name="combinedInsurance" /> -->
    <StoryblokButton v-if="button?.length" v-editable="button[0]" v-bind="button[0]" submit />
    <StoryblokButton v-if="secondaryButton?.length" v-editable="secondaryButton[0]" v-bind="secondaryButton[0]" />
  </FormSimple>
</template>
